import { OrgWidgetSettings } from 'sb-lib/types';
import { BusinessRulesConditions } from 'sb-lib/types/business-rules-types';

export interface ToggleButtonVisibility {
  operator: string;
  order: number;
}

type ButtonDesignerRuleActions = ToggleButtonVisibility;

export interface ButtonDesignerRule {
  id?: number;
  name: string;
  order: number;
  enabled: boolean;
  conditions: BusinessRulesConditions;
  actions: ButtonDesignerRuleActions[];
}

export interface DesignerRuleSetAttributeArgument {
  attributeName: keyof OrgWidgetSettings;
  value: OrgWidgetSettings[keyof OrgWidgetSettings];
}

export interface DesignerRuleExpandWidgetArgument {
  cssSelector: string;
  delayMs: number;
  expandOn: 'visit' | 'click' | 'form';
  oncePerSession: boolean;
}

export interface DesignerRuleAction<T extends 'set_attribute' | 'expand_widget'> {
  order: number;
  operator: T;
  arguments: T extends 'set_attribute'
    ? DesignerRuleSetAttributeArgument
    : DesignerRuleExpandWidgetArgument;
}
export interface DesignerRule {
  id?: number;
  name?: string;
  order?: number;
  enabled: boolean;
  conditions: BusinessRulesConditions;
  actions: DesignerRuleAction<'set_attribute' | 'expand_widget'>[];
}

export enum DesignerRuleGroup {
  CALL_BUTTON = 'call_button',
  CHAT_BUTTON = 'chat_button',
  MEETING_BUTTON = 'meeting_button',
  GENERAL = 'general',
}

export interface WidgetBackground {
  id: number;
  userId: number | null;
  videoUrl: string;
  photoUrl: string;
}
